// @ts-nocheck

export const localeCodes =  [
  "de",
  "en",
  "fr",
  "it",
  "pl",
  "es",
  "pt",
  "nl",
  "ja",
  "zh"
]
export const localeLoaders = {
  de: [
    {
      key: "locale_de_46ts_32f8e886",
      load: () => import("#nuxt-i18n/32f8e886" /* webpackChunkName: "locale_de_46ts_32f8e886" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46ts_2599ba0b",
      load: () => import("#nuxt-i18n/2599ba0b" /* webpackChunkName: "locale_en_46ts_2599ba0b" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_88706036",
      load: () => import("#nuxt-i18n/88706036" /* webpackChunkName: "locale_fr_46ts_88706036" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46ts_207f86dd",
      load: () => import("#nuxt-i18n/207f86dd" /* webpackChunkName: "locale_it_46ts_207f86dd" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46ts_7ba77f62",
      load: () => import("#nuxt-i18n/7ba77f62" /* webpackChunkName: "locale_pl_46ts_7ba77f62" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46ts_633ea246",
      load: () => import("#nuxt-i18n/633ea246" /* webpackChunkName: "locale_es_46ts_633ea246" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46ts_1bf5b1f6",
      load: () => import("#nuxt-i18n/1bf5b1f6" /* webpackChunkName: "locale_pt_46ts_1bf5b1f6" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46ts_c84cc67e",
      load: () => import("#nuxt-i18n/c84cc67e" /* webpackChunkName: "locale_nl_46ts_c84cc67e" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46ts_050cbd08",
      load: () => import("#nuxt-i18n/050cbd08" /* webpackChunkName: "locale_ja_46ts_050cbd08" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_46ts_4e249de9",
      load: () => import("#nuxt-i18n/4e249de9" /* webpackChunkName: "locale_zh_46ts_4e249de9" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "de",
    currency: "EUR",
    iso: "de-DE",
    displayLanguage: "Deutsch",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "en",
    currency: "USD",
    iso: "en-US",
    displayLanguage: "English",
    defaultServerLocation: "iad01",
    language: undefined
  },
  {
    code: "fr",
    currency: "EUR",
    iso: "fr-FR",
    displayLanguage: "Français",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "it",
    currency: "EUR",
    iso: "it-IT",
    displayLanguage: "Italiano",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "pl",
    currency: "EUR",
    iso: "pl-PL",
    displayLanguage: "Polski",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "es",
    currency: "EUR",
    iso: "es-ES",
    displayLanguage: "Español",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "pt",
    currency: "EUR",
    iso: "pt-PT",
    displayLanguage: "Português",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "nl",
    currency: "EUR",
    iso: "nl-NL",
    displayLanguage: "Nederlands",
    defaultServerLocation: "fra01",
    language: undefined
  },
  {
    code: "ja",
    currency: "JPY",
    iso: "ja-JP",
    displayLanguage: "日本語",
    defaultServerLocation: "hnd01",
    language: undefined
  },
  {
    code: "zh",
    currency: "USD",
    iso: "zh-CN",
    displayLanguage: "中文",
    defaultServerLocation: "tpe01",
    language: undefined
  }
]

